// popup(magnific)
jQuery(function($) {
  // ▼動画
  if ($('.js-popup-video').length) {
    $('.js-popup-video').magnificPopup({
      type: 'iframe',
      removalDelay: 300,
      preloader: true,
      callbacks: {
        beforeOpen: function() {
          // mfp-with-anim クラスをマークアップに追加
           this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
           this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
    });
  }
  // ▼画像
  if ($('.js-popup-image').length) {
    $('.js-popup-image').magnificPopup({
      type: 'image',
      removalDelay: 300,
      preloader: true,
      callbacks: {
        beforeOpen: function() {
          // mfp-with-anim クラスをマークアップに追加
           this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
           this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
    });
  }
  // ▼ajaxで別ページモーダル表示
  if ($('.js-popup-cont').length) {
    $('.js-popup-cont').magnificPopup({
      type: 'ajax',
      removalDelay: 300,
      preloader: true,
      callbacks: {
        beforeOpen: function() {
          // mfp-with-anim クラスをマークアップに追加
           this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
           this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
    });
  }
});
